export enum ProgramType {
  BasicEducationPrograms = 1,
  CraftsAndArtsTrainingPrograms = 2,
  MiddleSchoolShorterThanThreeYearsPrograms = 3,
  MiddleSchoolThreeYearsPrograms = 4,
  MiddleSchoolLongerThanThreeYearsPrograms = 5,
  CraftsSpecializationPrograms = 6,
  TrainingPrograms = 7,
  RefinementPrograms = 8,
  ForeignLanguageLearningPrograms = 9,  
  NewVocationalCurriculum = 10,
  BasicArtsPrograms = 11,
  MiddleSchoolArtsProgramsLongerThanThreeYears = 12,
  CroatianLanguageForForeigners = 13
}
